const labels: Record<string, string> = {
  active: "Aktif",
  pending: "Belum diverifikasi",
  error: "Perlu perhatian",
  revoked: "Dicabut",
  not_configured: "Belum diatur",
  test: "Test",
  trial: "Trial",
  suspended: "Suspend",
  grace_period: "Masa tenggang",
  expired: "Kedaluwarsa",
  cancelled: "Dibatalkan",
  draft: "Draf",
  awaiting_payment: "Menunggu bayar",
  queued: "Antre",
  preparing: "Disiapkan",
  ready: "Siap",
  served: "Disajikan",
  completed: "Selesai",
  unpaid: "Belum dibayar",
  paid: "Dibayar",
  failed: "Gagal",
  refunded: "Refund",
  partially_refunded: "Refund sebagian",
};

function tone(status: string): string {
  if (status === "active" || status === "paid") return "success";
  if (status === "completed" || status === "served" || status === "ready") {
    return "success";
  }
  if (
    status === "pending" ||
    status === "grace_period" ||
    status === "unpaid" ||
    status === "awaiting_payment" ||
    status === "queued" ||
    status === "preparing"
  ) {
    return "warning";
  }
  if (status === "error" || status === "revoked" || status === "failed") {
    return "danger";
  }
  if (status === "expired" || status === "cancelled" || status === "suspended")
    return "danger";
  if (
    status === "test" ||
    status === "trial" ||
    status === "refunded" ||
    status === "partially_refunded"
  ) {
    return "info";
  }
  return "neutral";
}

export function StatusBadge({
  status,
  label,
}: {
  status: string;
  label?: string;
}) {
  return (
    <span className={`badge badge--${tone(status)}`}>
      <span className="badge__dot" />
      {label ?? labels[status] ?? status}
    </span>
  );
}
